export default __webpack_public_path__ + "static/media/account_white.1428095a.svg";